import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useAppDispatch } from "../../stores/store";
import { setToast } from "../../stores/toast/toastslice";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Header,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import CustomButton from "../../components/common-components/CustomButton";
import { ActiveClientIcon, ActiveInactiveIcon, CrossIcon } from "../../assets/Icon/ModalIcon";
import { getErrorMessage } from "../../utils/functions";
import {
  activeInactiveClient,
  ClientDetailData,
  getClientList,
} from "../../stores/clients";

interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  id: any;
  onSuccess?: () => void;
  status: string;
}

export default function ActiveInactiveClientModal({
  open,
  handleClose,
  id,
  onSuccess,
  status,
}: ModalPropType) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleStatusToggle = async () => {
    setLoading(true);
    try {
      const response = await dispatch<any>(activeInactiveClient(id)).unwrap();

      if (response?.status === 1) {
        dispatch<any>(setToast({ type: "success", message: response?.message }));

        // dispatch(getClientList({ search: "" }));

        if (onSuccess) {
          onSuccess();
        }
        handleClose();
      } else {
        dispatch<any>(setToast({ type: "error", message: response?.message }));
      }
    } catch (error) {
      dispatch<any>(setToast({ type: "error", message: getErrorMessage(error) }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="status-modal-title"
      sx={{ zIndex: 99 }}
    >
      <ModalWrapper
        sx={{
          width: isMobile ? "90%" : "45%",
          maxWidth: "498px",
          minHeight: "350px",
          maxHeight: "602px",
          margin: "auto",
          overflow: "hidden",

          p: isMobile ? 2 : 3,
        }}
      >
        <CloseButtonWrapper>
          <CloseButton onClick={handleClose}>
            <CrossIcon />
          </CloseButton>
        </CloseButtonWrapper>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // margin: "20px 0",
          }}
        >
           {status === "Active" ?  <ActiveInactiveIcon /> :  <ActiveClientIcon />}
         
        </Box>

        <Content sx={{ textAlign: "center", padding: "0 20px" }}>
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 700,
              marginBottom: "12px",
            }}
          >
            {status === "Active" ? "Inactive Client" : "Active Client"}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              textAlign: "center",
              marginBottom: "20px",
              lineHeight: "1.5",
              color: "#6C6F71",
            }}
          >
            Are you sure you want to{" "}
            {status === "Active" ? "inactive" : "active"} this client?
          </Typography>
        </Content>

        <ButtonWrapper
          sx={{
            display: "flex",
            marginTop: "15px",
            marginBottom: "15px",
            justifyContent: isMobile ? "center" : "space-between",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "10px" : "2px",
          }}
        >
          <CustomButton
            btnTitle="No"
            handleClick={handleClose}
            disabled={loading}
            minwidth={isMobile ? "100%" : "45%"}
            bgColor="#FFF"
            textColor="#2977CC"
            borderColor={loading ? "transparent" : "#2977CC"}
            borderWidth={2.3}
            sx={{ fontSize: "18px" }}
          />
          <CustomButton
            btnTitle={"Yes"}
            handleClick={handleStatusToggle}
            disabled={loading}
            loading={loading}
            minwidth={isMobile ? "100%" : "45%"}
            borderColor={loading ? "transparent" : "#2977CC"}
            sx={{ fontSize: "18px" }}
          />
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
}
